import Vue from 'vue'
import service from '../services/bankAccountsService'

export function useReportTransactions() {
  const state = Vue.observable({
    items: [],
    currentPage: 1,
    lastPage: 1,
    loading: false
  })

  async function getReportTransactions(params = {}) {
    state.loading = true
    try {
      const response = await service.getReportTransactions(params)
      state.items = response.transactions.current_page === 1
        ? [...response.transactions.data]
        : [...state.items, ...response.transactions.data]
      state.currentPage = response.transactions.current_page
      state.lastPage = response.transactions.last_page
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  return { state, getReportTransactions }
}
